import { MouseEvent, ReactNode } from 'react';
import { IconButton } from '@mui/material';
import { ChevronLeft, Menu } from 'lucide-react';

import { CustomEvents } from '@labradorsports/constants';

interface Props {
    title: string;
    subtitle?: string;
    actionMenu?: any;
    onBack?: (evt: MouseEvent<any, any>) => any;
    children?: ReactNode;
}

const PanelHeader: FC<Props> = ({ title, subtitle, actionMenu, onBack, children }) => {
    const classes = ['panel-header'];
    if (actionMenu) classes.push('has-action-menu');
    if (onBack) classes.push('has-back-button');

    const backHandler = (evt) => {
        if (onBack) {
            onBack(evt);
        } else {
            window.dispatchEvent(new Event(CustomEvents.LEFT_PANEL_OPEN));
        }
    };

    return (
        <div className={classes.join(' ')}>
            <div className="panel-header-width">
                <div className="back-button">
                    <IconButton onClick={backHandler}>{onBack ? <ChevronLeft /> : <Menu />}</IconButton>
                </div>
                <div className="panel-header-content">
                    <div className="header-text">
                        <h1 className="panel-header-title">{title}</h1>
                        <small>{subtitle}</small>
                    </div>
                    {children}
                </div>
                <div className="action-menu">{actionMenu}</div>
            </div>
        </div>
    );
};

export default PanelHeader;
